import {
  PROFILE_UPDATE_PERSON_INFO_BEGIN,
  PROFILE_UPDATE_PERSON_INFO_SUCCESS,
  PROFILE_UPDATE_PERSON_INFO_FAILURE,
  PROFILE_UPDATE_PERSON_INFO_DISMISS_ERROR,
} from './constants';
import{ SERVER_PATH,AXIOS_CONFIG } from '../../common/redux/constantes';
import axios from 'axios';

// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function updatePersonInfo(user,args = {}) {
  return (dispatch,getState) => { // optionally you can have getState as the second argument
    dispatch({
      type: PROFILE_UPDATE_PERSON_INFO_BEGIN,
    });
    let profileInfo = getState().profile.profileInfo;
    let userId = localStorage.getItem("user_id")
    user.id  = userId
    // Return a promise so that you could control UI flow without states in the store.
    // For example: after submit a form, you need to redirect the page to another when succeeds or show some errors message if fails.
    // It's hard to use state to manage it, but returning a promise allows you to easily achieve it.
    // e.g.: handleSubmit() { this.props.actions.submitForm(data).then(()=> {}).catch(() => {}); }
    const promise = new Promise((resolve, reject) => {
      // doRequest is a placeholder Promise. You should replace it with your own logic.
      // See the real-word example at:  https://github.com/supnate/rekit/blob/master/src/features/home/redux/fetchRedditReactjsList.js
      // args.error here is only for test coverage purpose.
      axios.post(SERVER_PATH + '/profile/updatePersonInfo', {
        user:user,
      }, AXIOS_CONFIG())
      .then(
        (res) => {
          dispatch({
            type: PROFILE_UPDATE_PERSON_INFO_SUCCESS,
            data: res,
            user:user,
            profileInfo:profileInfo
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: PROFILE_UPDATE_PERSON_INFO_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissUpdatePersonInfoError() {
  return {
    type: PROFILE_UPDATE_PERSON_INFO_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case PROFILE_UPDATE_PERSON_INFO_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        updatePersonInfoPending: true,
        updatePersonInfoError: null,
      };

    case PROFILE_UPDATE_PERSON_INFO_SUCCESS:
      // The request is success
      // here we set up the new username and the new token 
      let showSuccess=false
      if(action.data.data.success===1){
        action.profileInfo.names=action.user.names
        action.profileInfo.surnames=action.user.surnames
        localStorage.setItem("username", action.user.username);
        localStorage.setItem("user_token", action.data.data.token);
        showSuccess=true
      }
      action.profileInfo.username=action.user.username
      return {
        ...state,
        profileInfo:action.profileInfo,
        loadingPerson:false,
        updatePersonInfoPending: false,
        updatePersonInfoError: null,
        checkingMessage: action.data.data.type===2? action.data.data.message:"",
        updatingSuccess:showSuccess
      };

    case PROFILE_UPDATE_PERSON_INFO_FAILURE:
      // The request is failed
      return {
        ...state,
        updatePersonInfoPending: false,
        updatePersonInfoError: action.data.error,
      };

    case PROFILE_UPDATE_PERSON_INFO_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        updatePersonInfoError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/profile/redux/updatePersonInfo.js